import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import ProcessSection from "./components/ProcessSection";
import InfoSection from "./components/InfoSection";
import AccessSection from "./components/AccessSection";
import CtaFooter from "./components/CtaFooter";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ProcessSection />
        <InfoSection />
        <AccessSection />
        <CtaFooter />
      </main>
    </div>
  );
}
